import player from "./player";
import video from "./video";
import modal from './modal';
import node from './node';
import project from "./project";

const getters = {
    dynamicParams:state => state.dynamicParams,
    isMobile: state => state.isMobile,
    userId : state => state.project.user_id
};

export default {...getters, ...player, ...video, ...modal, ...node, ...project};